
import {Component, Mixins, Prop, Vue, Watch} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
@Component({})
export default class UyapImzaBilgi extends Mixins(SimpleInputMixin){
@Prop() senkronizeTarih!:string;
}
